import React, { useState } from 'react';
import { getEnvUrl,getToken } from "../utils/Api";

const ClearCache = () => {
  const [loading, setLoading] = useState(false);
  const [clearCacheVisible, setClearCacheVisible] = useState(true);

  const handleClearCache = async () => {
    try {
      const result = window.confirm('Are you sure to delete cache from server?');
      if (result) {
        setLoading(true);
        setClearCacheVisible(false);
        const response = await fetch(`${getEnvUrl()}/cache/deleteCache`, {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${getToken()}`,
          },
        });
        const data = await response.json();

        setLoading(false);
        setClearCacheVisible(true);
        if (data.status) {
          window.alert(data.message);
        } else {
          window.alert(data.errorMessage);
        }
      }
    } catch (error) {
      window.alert(error.statusText);
      setLoading(false);
    }
  };

  return (
    <div>
    <a className="nav-link nav-icon" href="#" onClick={handleClearCache}>
      <i className="bi bi-arrow-clockwise" title="Clear cache" style={{ display: clearCacheVisible ? 'inline-block' : 'none' }}></i>
    </a>
    <a className="nav-link nav-icon" href="#" id="clearcachespinner" style={{ display: loading ? 'inline-block' : 'none' }}>
      <span className="spinner-border"  role="status" aria-hidden="true"></span>
    </a>
    </div>
  );
};

export default ClearCache;